import ProductListPage from "../../../../components/List/ProductListPage";

export const OrganizationProductCompositionIndexPage = () => {
	return <ProductListPage productType="COMPOSITE" />;
};
